/** Local analytics consent (≠ CGU). Host-only; not shared with doc.cncc.fr. */

export const MATOMO_CONSENT_STORAGE_KEY = "sidoniassist_matomo_consent";

export type MatomoConsentState = "granted" | "denied" | "unknown";

export function readMatomoConsent(): MatomoConsentState {
  if (typeof window === "undefined") {
    return "unknown";
  }
  try {
    const value = window.localStorage.getItem(MATOMO_CONSENT_STORAGE_KEY);
    if (value === "granted" || value === "denied") {
      return value;
    }
  } catch {
    // private mode / blocked storage
  }
  return "unknown";
}

export function writeMatomoConsent(state: "granted" | "denied"): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(MATOMO_CONSENT_STORAGE_KEY, state);
  } catch {
    // ignore
  }
}
